import React, { Component } from 'react';
import { connect } from 'react-redux';
import GroupDetails from './GroupDetails.js';
import { withRouter } from '../../common/utils/NavigationWrapper';
import {
  getGroup,
  moveInstrumentToGroup,
  getInstrumentsOfGroup,
  removeUserFromGroup,
  getUsersOfGroup,
  updateGroup,
  addUserToGroup,
  getAssignableUsersToGroup,
  addInstrumentToGroup,
  removeInstrumentFromGroup,
  getAssignableIstrumentsToGroup,
} from './GroupDetails.actions';
import Loading from '../../common/components/Loading/Loading';
import Store from '../../redux/Store';
import { showSnackbar } from '../../common/state/snackbar/Snackbar.actions';
import Constants from '../../common/constants/Constants';
import Validators from '../../common/utils/Validators';

class GroupDetailsContainer extends Component {
  constructor() {
    super();
    this.state = {
      group: {},
      isFetching: false,
      users: [],
      assignableUsers: [],
      instruments: [],
      updateGroupErrorText: '',
      showAddUserDialog: { show: false, action: () => {}, cancel: () => {} },
      selectedUserId: null,
      selectedUserEmail: '',
      emailErrorMessage: '',
      showRemoveUserConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirmForRemovingUser: '',
      showMoveInstrumentConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirmForMovingInstrument: '',
      showAddInstrumentDialog: { show: false, action: () => {}, cancel: () => {} },
      selectedInstrument: '',
      showRemoveInstrumentConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirmForRemovingInstrument: '',
      assignableInstruments: [],
    };
  }

  componentDidMount() {
    const { params } = this.props;
    let groupId = parseInt(params.id, 10);

    if (params.id) {
      this.setState({ isFetching: true }, () => this._loadData(groupId));
    }
  }

  _loadData = (groupId) => {
    let group = null;
    let users = null;
    let instruments = null;
    getGroup(groupId)
      .then((res) => {
        group = res.body;
        return getUsersOfGroup(groupId);
      })
      .then((res) => {
        users = res.body;
        return getInstrumentsOfGroup(groupId);
      })
      .then((res) => {
        console.log(res.body);
        if (JSON.stringify(res.body) === '[null,null]') {
          instruments = [];
        } else {
          instruments = res.body;
        }

        return getAssignableIstrumentsToGroup();
      })
      .then((res) => {
        let assignableInstruments;
        let r = res.body;
        if (!r.Data || !r.Display) {
          assignableInstruments = [];
        }
        assignableInstruments = r.Data.slice(0);

        this.setState({
          group,
          users,
          instruments,
          assignableInstruments,
          isFetching: false,
        });
      });
  };

  render() {
    return (
      <Loading condition={this.state.isFetching}>
        <GroupDetails
          group={this.state.group}
          users={this.state.users}
          instruments={this.state.instruments}
          updateGroupErrorText={this.state.updateGroupErrorText}
          onChangeCallback={this._onChangeGroupName}
          onSubmitChangeGroupName={this._onSubmitChangeGroupName}
          showAddUserDialog={this.state.showAddUserDialog}
          openAddUserDialogCallback={this._openAddUserDialogCallback}
          selectedUserId={this.state.selectedUserId}
          handleSelectedUser={this._handleSelectedUser}
          selectedUserEmail={this.state.selectedUserEmail}
          handleSelectedUserEmail={this._handleUserEmail}
          emailErrorMessage={this.state.emailErrorMessage}
          assignableUsers={this.state.assignableUsers}
          onRemoveUserCallback={this._onRemoveUserCallback}
          showRemoveUserConfirmDialog={this.state.showRemoveUserConfirmDialog}
          messageToConfirmForRemovingUser={this.state.messageToConfirmForRemovingUser}
          showMoveInstrumentConfirmDialog={this.state.showMoveInstrumentConfirmDialog}
          messageToConfirmForMovingInstrument={this.state.messageToConfirmForMovingInstrument}
          showAddInstrumentDialog={this.state.showAddInstrumentDialog}
          openAddInstrumentDialogCallback={this._openAddInstrumentDialogCallback}
          handleSelectedInstrument={this._handleSelectedInstrument}
          selectedInstrument={this.state.selectedInstrument}
          onRemoveInstrumentCallback={this._onRemoveInstrumentCallback}
          showRemoveInstrumentConfirmDialog={this.state.showRemoveInstrumentConfirmDialog}
          messageToConfirmForRemovingInstrument={this.state.messageToConfirmForRemovingInstrument}
          assignableInstruments={this.state.assignableInstruments}
        />
      </Loading>
    );
  }

  _openAddUserDialogCallback = () => {
    getAssignableUsersToGroup(this.state.group.GroupId)
      .then((res) => {
        this.setState({
          assignableUsers: res.body,
          showAddUserDialog: {
            show: true,
            title: 'Add user to group',
            action: this._addUser,
            cancel: this._cancelAddUser,
          },
        });
      })
      .catch((err) => this._showFailMessage('Error occured while adding user.'));
  };

  _addUser = () => {
    let userIdToAssignToGroup = null;

    if (
      this.state.selectedUserEmail != '' &&
      this.state.assignableUsers.some((e) => e.Email == this.state.selectedUserEmail)
    ) {
      userIdToAssignToGroup = this.state.assignableUsers.find(
        (e) => e.Email == this.state.selectedUserEmail
      ).UserEntityId;
    } else if (this.state.selectedUserId != null) {
      userIdToAssignToGroup = this.state.selectedUserId;
    }

    if (userIdToAssignToGroup == null) {
      this._showFailMessage('Empty or invalid user email!');
    } else {
      this.setState({ showAddUserDialog: { disableMainAction: true } });

      addUserToGroup(this.state.group.GroupId, userIdToAssignToGroup)
        .then((res) => {
          return getUsersOfGroup(this.state.group.GroupId);
        })
        .then((res) => {
          this.setState({
            users: res.body,
            selectedUserId: null,
            selectedUserEmail: '',
            showAddUserDialog: {
              disableMainAction: false,
              show: false,
              action: () => {},
              cancel: () => {},
            },
          });
        })
        .then((res) => {
          this._showSuccesMessage('User successfully assigned to group.');
        })
        .catch((err) => this._showFailMessage('', err));
    }
  };

  _cancelAddUser = () => {
    this.setState({
      selectedUserId: null,
      selectedUserEmail: '',
      emailErrorMessage: '',
      showAddUserDialog: {
        disableMainAction: false,
        show: false,
        action: () => {},
        cancel: () => {},
      },
    });
  };

  _handleSelectedUser = (event) => {
    this.setState({ selectedUserId: event });
  };

  _handleUserEmail = (event) => {
    let validationMessage = this._getValidationErrorMessage('Email', event);
    this.setState({ selectedUserEmail: event, emailErrorMessage: validationMessage });
  };

  _getValidationErrorMessage = (propertyName, value) => {
    let validationMessage = '';

    switch (propertyName) {
      case 'Email': {
        if (value !== '' && !Validators.validateEmail(value)) {
          validationMessage = 'Enter an email address in the form of address@domain.com';
        } else if (
          value !== '' &&
          !Validators.validateEmailInDomainList(
            value,
            this.props.globalSettings[Constants.SETTING_KEYS.ALLOWED_USER_EMAIL_DOMAINS]
          )
        ) {
          validationMessage = 'Invalid email domain. Please use company email';
        }
      }
      case 'GroupName': {
        if (!Validators.validateStringBetweenRange(value, 1, 200)) {
          validationMessage =
            'Enter an alphanumeric value between 1 and 200 characters; for example: Group 01';
        }
      }
    }

    return validationMessage;
  };

  _openAddInstrumentDialogCallback = () => {
    this.setState({
      showAddInstrumentDialog: {
        show: true,
        action: this._addInstrument,
        cancel: this._cancelAddInstrument,
      },
    });
  };

  _addInstrument = () => {
    if (this.state.selectedInstrument) {
      const instrument = this.state.selectedInstrument.SerialNumber;

      addInstrumentToGroup(this.state.group.GroupId, instrument)
        .then((res) => {
          if (res.body == null) {
            //instrument is already assigned to a group, show dialog for confirm move
            this.setState({
              selectedInstrument: '',
              showAddInstrumentDialog: {
                show: false,
                action: () => {},
                cancel: () => {},
              },
              messageToConfirmForMovingInstrument: `The instrument with serial number "${instrument}" is already assigned to another group. Would you like to move it to the group "${this.state.group.Name}"?`,
              showMoveInstrumentConfirmDialog: {
                title: `Move instrument ${instrument}`,
                show: true,
                action: () => this._onConfirmMoveInstrument(instrument),
                cancel: this._onCancelMoveInstrument,
                mainActionLabel: 'Yes',
              },
            });
            return true;
          } else {
            this._showSuccesMessage('Instrument successfully added.');
            return getInstrumentsOfGroup(this.state.group.GroupId);
          }
        })
        .then((res) => {
          if (res.body != null) {
            this.setState({
              instruments: res.body,
              selectedInstrument: '',
              showAddInstrumentDialog: {
                show: false,
                action: () => {},
                cancel: () => {},
              },
            });
          }
        })
        .catch((err) => {
          this._showFailMessage('Adding the instrument failed.', err);
        });
    } else {
      this._showFailMessage('Empty serial number!');
    }
  };

  _cancelAddInstrument = () => {
    this.setState({
      selectedInstrument: '',
      showAddInstrumentDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
      },
    });
  };

  _handleSelectedInstrument = (event) => {
    this.setState({ selectedInstrument: event });
  };

  _onChangeGroupName = (propertyName, value) => {
    let newGroup = {
      ...Object.assign({}, this.state.group),
      [propertyName]: value,
    };

    this.setState((prevState) => ({
      group: newGroup,
      updateGroupErrorText:
        prevState.group.Name != newGroup.Name
          ? this._getValidationErrorMessage('GroupName', value)
          : prevState.updateGroupErrorText,
    }));
  };

  _onSubmitChangeGroupName = () => {
    if (this.state.group.Name) {
      let updatedGroup = {};
      updateGroup(this.state.group)
        .then((res) => {
          updatedGroup = res.body;
          this.setState(
            {
              group: updatedGroup,
            },
            () => this._showSuccesMessage('Successfully updated.')
          );
        })
        .catch((err) => this._showFailMessage('', err));
    } else {
      this._showFailMessage('Empty group name or similar group name already exists!');
    }
  };

  _onRemoveUserCallback = (user) => {
    this.setState({
      messageToConfirmForRemovingUser: `Are you sure you want to remove user "${user.Username}" from "${this.state.group.Name}"?`,
      showRemoveUserConfirmDialog: {
        title: `Remove user ${user.Username}`,
        show: true,
        action: () => this._onConfirmRemoveUser(user),
        cancel: this._onCancelRemoveUser,
        mainActionLabel: 'Yes',
      },
    });
  };

  _onConfirmRemoveUser = (user) => {
    if (user) {
      this.setState({ showRemoveUserConfirmDialog: { disableMainAction: true } });
      removeUserFromGroup(this.state.group.GroupId, user.UserEntityId)
        .then((res) => {
          return getUsersOfGroup(this.state.group.GroupId);
        })
        .then((res) => {
          this.setState({
            users: res.body,
            selectedUserId: null,
            messageToConfirmForRemovingUser: '',
            showRemoveUserConfirmDialog: {
              show: false,
              disableMainAction: false,
              action: () => {},
              cancel: () => {},
            },
          });
          this._showSuccesMessage('Successfully removed.');
        })
        .catch((err) => this._showFailMessage('Could not remove user. '));
    }
  };

  _onCancelRemoveUser = () => {
    this.setState({
      messageToConfirmForRemovingUser: '',
      showRemoveUserConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
    });
  };

  _onRemoveInstrumentCallback = (event, instrument) => {
    this.setState({
      messageToConfirmForRemovingInstrument: `Are you sure you want to remove instrument "${instrument.SerialNumber}" from "${this.state.group.Name}"?`,
      showRemoveInstrumentConfirmDialog: {
        title: `Remove instrument ${instrument.SerialNumber}`,
        show: true,
        action: () => this._onConfirmRemoveInstrument(instrument),
        cancel: this._onCancelRemoveInstrument,
        mainActionLabel: 'Yes',
      },
    });
    event.stopPropagation();
  };

  _onConfirmRemoveInstrument = (instrument) => {
    if (instrument) {
      this.setState({ showRemoveInstrumentConfirmDialog: { disableMainAction: true } });
      removeInstrumentFromGroup(this.state.group.GroupId, instrument.SerialNumber)
        .then((res) => {
          return getInstrumentsOfGroup(this.state.group.GroupId);
        })
        .then((res) => {
          this.setState({
            instruments: res.body,
            selectedInstrument: null,
            messageToConfirmForRemovingInstrument: '',
            showRemoveInstrumentConfirmDialog: {
              show: false,
              disableMainAction: false,
              action: () => {},
              cancel: () => {},
            },
          });
          this._showSuccesMessage('Successfully removed.');
        })
        .catch((err) => this._showFailMessage('Could not remove instrument. '));
    }
  };

  _onCancelRemoveInstrument = () => {
    this.setState({
      messageToConfirmForRemovingInstrument: '',
      showRemoveInstrumentConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
    });
  };

  _onConfirmMoveInstrument = (instrumentSerialnumber) => {
    if (instrumentSerialnumber) {
      this.setState({ showMoveInstrumentConfirmDialog: { disableMainAction: true } });
      moveInstrumentToGroup(this.state.group.GroupId, instrumentSerialnumber)
        .then((res) => {
          return getInstrumentsOfGroup(this.state.group.GroupId);
        })
        .then((res) => {
          this.setState({
            instruments: res.body,
            selectedInstrument: '',
            messageToConfirmForMovingInstrument: '',
            showMoveInstrumentConfirmDialog: {
              show: false,
              disableMainAction: false,
              action: () => {},
              cancel: () => {},
            },
          });
          this._showSuccesMessage('Successfully moved.');
        })
        .catch((err) => this._showFailMessage('Could not move instrument.', err));
    }
  };

  _onCancelMoveInstrument = () => {
    this.setState({
      messageToConfirmForMovingInstrument: '',
      showMoveInstrumentConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
    });
  };

  _showSuccesMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
        message: theMessage,
      })
    );
  }

  _showFailMessage(theMessage, err) {
    let messageToShow = theMessage;
    if (err != null) {
      messageToShow +=
        err.response && err.response.body.Message
          ? err.response.body.Message
          : Constants.DEFAULT_ERROR_MESSAGE;
    }

    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
        message: messageToShow,
      })
    );
  }
}

const mapStateToProps = (state) => ({
  globalSettings: state.user ? state.user.Settings : undefined,
});

export default withRouter(connect(mapStateToProps)(GroupDetailsContainer));
